module.exports = __webpack_public_path__ + "build/img/NEGATIVE.19a03f3a.svg";